module.exports = "<svg id=\"87bbea6b-fefc-40a7-8630-42d71d9ead81\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 43 69.21\"><title>NextRt</title><g id=\"df96d44b-d673-464a-998e-13e064b69288\" data-name=\"Page-1\"><g id=\"e304ba08-2a36-4932-8cd8-c546654f426d\" data-name=\"Artboard\"><polygon id=\"23107f50-7804-4c21-bd33-7238f947f9c0\" data-name=\"Fill-1\" points=\"0 0 0 22.8 15 34.6 0 46.41 0 69.21 43 34.6 0 0\" style=\"fill:#6dc200\"></polygon></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/right.svg
// module id = 4hpK
// module chunks = 0